<div class="modal fade" id="addModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header mb-3">
				<button type="button" class="btn-close" (click)="dialogClose()"></button>
			</div>
			<div class="container text-center">
				<ul class="list-inline">
					@for (item of tableColumns(); track item.id) {
						<li class="list-inline-item">
							@if (item.name) {
								<button
									mat-raised-button
									class="mb-2"
									[color]="settings().hiddenColumns.includes(item.id) ? 'basic' : 'primary'"
									(click)="showHideRow(item.id)"
								>
									{{ item.name }}
								</button>
							}
						</li>
					}
				</ul>
			</div>
		</div>
	</div>
</div>

<mat-table
	#dataTable
	[dataSource]="tableData()"
	matSort
	matSortDirection="asc"
	(matSortChange)="onSortChange($event)"
	class="mat-elevation-z4"
>
	@for (item of tableColumns(); track item.id) {
		<ng-container [matColumnDef]="item.id">
			<mat-header-cell *matHeaderCellDef class="custom-header" mat-sort-header [disabled]="!isSortable(item.id)">
				{{ item.name }}
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				@switch (item.id) {
					@case ('payment') {
						<span>{{ element.payment | date: 'yyyy-MM-dd' }}</span>
					}
					@case ('posting') {
						<span>{{ element.posting | date: 'yyyy-MM-dd' }}</span>
					}
					@case ('status') {
						<span>{{ element.status | paymentStatusLabel }}</span>
					}
					@case ('kind') {
						<span>{{ element.kind?.description }}</span>
					}
					@case ('amount') {
						<span>{{ element.amount | price }} {{ element.currency | currencyCode }}</span>
					}
					@case ('payer') {
						<span>{{ element.userData?.firstName }} {{ element.userData?.lastName }}</span>
					}
					@case ('bankAccountPosting') {
						<span>{{ bankAccountNumberById()[element.bankAccountPosting] ?? '' }}</span>
					}
					@case ('reservationStatus') {
						<span>{{ element.reservationStatus | statusLabel }}</span>
					}
					@case ('tableId') {
						<a [href]="'reservation/' + element.tableId" target="_blank">BAG {{ element.tableId }}</a>
					}
					@default {
						<span>{{ element[item.id] }}</span>
					}
				}
			</mat-cell>
		</ng-container>
	}
	<ng-container matColumnDef="columnShow">
		<mat-header-cell *matHeaderCellDef
			><button mat-icon-button [matMenuTriggerFor]="option">
				<i class="fa-solid fa-ellipsis-vertical"></i>
			</button>
			<mat-menu class="custom-mat-menu" #option="matMenu">
				<button mat-menu-item (click)="openDialog()">Widok kolumn<i class="fas fa-eye ms-2"></i></button>
				<button mat-menu-item (click)="onExportCsv()">Pobierz CSV<i class="fas fa-clipboard ms-2"></i></button>
			</mat-menu>
		</mat-header-cell>
		<mat-cell *matCellDef="let element"></mat-cell>
	</ng-container>
	<mat-header-row *matHeaderRowDef="showColumns()" class="mat-header-custom"></mat-header-row>
	<mat-row *matRowDef="let row; columns: showColumns(); let i = index" [ngClass]="{ second: !(i % 2) }"></mat-row>
</mat-table>

@if (hasNoResults()) {
	<div class="mat-elevation-z4 py-5 text-center">Brak wyników</div>
}

@if (allItemsSize() > 0) {
	<mat-paginator
		class="mat-elevation-z4"
		(page)="pageChanged($event)"
		[pageIndex]="pageIndex()"
		[pageSize]="pageSize()"
		[length]="allItemsSize()"
		[pageSizeOptions]="[25, 50, 100]"
		showFirstLastButtons
	>
	</mat-paginator>
}
